//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Fragment } from "react";

// custom pages
import { styles } from "../Promotion/Criteria/styles";
import milestonepromotion from "apis/milestonePromotion/milestonepromotion";
import Context from "context/context";
import Autocomplete from "@material-ui/lab/Autocomplete";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import Table from "components/Table/Table";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import { blue } from '@material-ui/core/colors';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from 'react-i18next';
import { Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function MilestoneCriteriaView(props) {
  const { state, dispatch } = useContext(Context);

  const { updateCriteria, searchCategory, getCriteriaAvailablePromo } = milestonepromotion();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  const {t, i18n}= useTranslation()
  const [states, setstates] = useState({
    category: "",
    searchLoading: false,
    searchData: [],
    searchCategoryValue: "",
    categoryValue: "",
    isActive: true,
    data: {},
    edittedData: {},
    isEdit: false,
    categoryType: false,
    priority: "",
  promoID: ""
  });

  const {
    category,
    searchLoading,
    searchData,
    searchCategoryValue,
    categoryValue,
    isActive,
    data,
    edittedData,
    isEdit,
    categoryType,
    priority,
    promoID
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));    
  }, []);

  const categoryValueDebounce = useDebounce(searchCategoryValue);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "PROMOTION", "CRITERIA", "VIEW"],
    });
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
      getAllPromo(dataObj);
    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      category: dataObj?.category,
      categoryValue: dataObj?.category_value,
      isActive: dataObj?.is_active,
      categoryType: dataObj?.category_type,
      priority: dataObj?.priority,
      promoID: dataObj?.promotion_id
    });
  };

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  // handling search api call
  useEffect(() => {
    if (categoryValueDebounce && categoryValueDebounce.length > 0) {
      handleSearch();
    }
  }, [categoryValueDebounce]);

  // handleSearch api func
  const handleSearch = async () => {
    setStates({ searchLoading: true });
    try {
      let values;
      values = {
        searchValue: searchCategoryValue,
        category: edittedData?.category,
      };
      let res = await searchCategory(values);
      if (res) {
        setStates({ searchData: res?.data, searchLoading: false });
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };

  // update api func
  const handleUpdate = async () => {
    try {
      if (Object.keys(edittedData)?.length == 0 || (edittedData?.category && !edittedData?.categoryValue)) {
        toast.error("Please fill the fields.", {
          toastId: "update-error",
        });
        return;
      }
      let failed = false;
      Object.keys(edittedData).map((o) => {
        if (!edittedData[o] && typeof edittedData[o] != "boolean") {
          failed = true;
        }
      });
      if (failed) {
        toast.error("Cannot update empty field.", {
          toastId: "update-error-2",
        });
        return;
      }
      let values;
      values = {
        ...edittedData,
        id: data?.id,
        category: category,
        categoryValue: categoryValue.replaceAll('-', '')
      };

      // if (edittedData?.categoryValue) {
      //   values = {
      //     ...values,
      //     categoryValue: parseInt(edittedData?.categoryValue),
      //   };
      // }

      let res = await updateCriteria(values);
      if (res?.data === 1) {
        toast.success("Updated", { toastId: "criteria-updated" });
        history.goBack();
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };

  const [selectedCriteria, setSelectedCriteria] = useState([]);  
  const [allPromo, setAllPromo] = useState([]);
  const [selectedPromo, setSelectedPromo] = useState();
  const GreenRadio = withStyles({
    root: {
      color: blue[400],
      '&$checked': {
        color: blue[600]
      }
    },
    checked: {},
  })((props) => <Radio color='default' {...props} />);
  const getAllPromo = async (dataObj) => {
    try {
      let values = {
        category: dataObj?.category,
        categoryValue: {value:dataObj?.category_value},
        isActive: dataObj?.is_active,
        promotionId: dataObj?.promotion_id,
        action: 'view'
      }; 
      let res = await getCriteriaAvailablePromo(values);
      if (res) { 
        let rows = res.data;
        setAllPromo(rows);
        rows.map((p) => {
          if (p.category_type===false) {
            if (p?.priority===true) {
              setSelectedPromo(p?.promotion_id);
            }            
          }
          else{
            setSelectedPromo(dataObj?.promotion_id);
          }
        });
      }      
    } 
    catch (e) {
      console.log({ e });
    }
  };
  const handleSelectPromo = async (pid) => {
    try {
      setSelectedPromo(pid);
      return;
    } 
    catch (e) {
      console.log({ e });
    }
  };

  const categoryLabels = {
    "product_primary_class_id": "MPC",
    "product_brand_name_code": "Brand",
    "product_code": "Product",
    "business_unit_code": "GL Cost Center",
    "label_class_code": "Label Class Code",
    "loyalty_category_code": "Sales Category",
    "order_source_code": "Order Source Code",
    "primary_major_class_code": "Primary Major Class Code",
    "primary_submajor_class_code": "Primary Submajor Class Code",
    "primary_minor_class_code": "Primary Minor Class Code",
    "loyalty_id": "Loyalty ID",
    "order_promotion_code": "Order Promotion Code",
     "order_level_coupon":"Order Level Coupon",
    "line_promo_coupon":"Line Promo Coupon",
    "promotion": "Promotion",
    "equipment_order_number":"Equipment Order Number"
  };
  
  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18 }}>
            <strong>{t("View")}</strong>
          </span>
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                setStates({ isEdit: true });
              }}
            >
              {t('Edit')}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Category')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {/* {isEdit ? (
                <CssTextField
                  id={"Category"}
                  variant="outlined"
                  select
                  fullWidth
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={category}
                  onChange={(e) => {
                    setStates({
                      edittedData: {
                        ...edittedData,
                        category: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "MPC", value: "MPC" },
                    { label: "GL Cost Center", value: "GL Cost Center" },
                    { label: "Label Class Code", value: "Label Class Code" },
                    { label: "Brand", value: "Brand" },
                    { label: "Sales Category", value: "Sales Category" },
                    { label: "Product Code", value: "Product Code" },
                    { label: "Order Source Code", value: "Order Source Code" },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (                
                <span className={classes.label}> {category}</span>
              )} */}
              <span className={classes.label}> {categoryLabels[category]}</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Category Value')}: </strong>
            </Grid>
            <Grid item xs={8}>
              {/* {isEdit ? (
                // <CssTextField
                //   variant="outlined"
                //   type={"number"}
                //   onKeyDown={blockInvalidChar}
                //   className={classes.cssTextField}
                //   required
                //   className={classes.editInput}
                //   value={categoryValue}
                //   onChange={(e) => {
                //     setStates({
                //       categoryValue: e.target.value,
                //       edittedData: {
                //         ...edittedData,
                //         categoryValue: e.target.value,
                //       },
                //     });
                //   }}
                // />
                <Autocomplete
                  options={searchData}
                  getOptionLabel={(obj) => obj?.value}
                  filterOptions={(options, state) => options}
                  inputValue={searchCategoryValue}
                  id="debug"
                  clearOnBlur={true}
                  className={classes.editInput}
                  // onClose={() => {
                  //   if(!categoryValue){
                  //   setStates({ searchCategoryValue: "" });}
                  // }}
                  disabled={!edittedData?.category}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      margin="none"
                      variant="outlined"
                      value={searchCategoryValue}
                      onChange={(e) => {
                        setStates({ searchCategoryValue: e.target.value });
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {searchLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                  onChange={(value, obj, reason) => {
                    if (reason === "clear") {
                      setStates({
                        edittedData: {
                          ...edittedData,
                          categoryValue: "",
                        },
                      });
                      return;
                    }
                    if (obj) {
                      setStates({
                        searchCategoryValue: obj.value,
                        edittedData: {
                          ...edittedData,
                          categoryValue: obj.value,
                        },
                      });
                    }
                  }}
                />

              ) : (
                <span className={classes.label}> {categoryValue}</span>
              )} */}
              <span className={classes.label}> {categoryValue}</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Status')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isActive}
                  onChange={(e) => {
                    setStates({
                      isActive: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isActive: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "Active", value: true },
                    { label: "Inactive", value: false },
                  ].map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {isActive == true ? 'Active' : 'Inactive'}</span>
              )}
            </Grid>
          </Grid>
        </Grid>
        
        {/* <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Category Type')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <FormControl style={{ marginRight: 5 }}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={true}
                    name="radio-buttons-group"
                    row
                    value={categoryType}
                    onChange={(e) => {
                      setStates({
                        categoryType:!categoryType,
                        edittedData: {
                          ...edittedData,
                          categoryType:!categoryType
                        }
                      });
                    }}
                  >
                    <FormControlLabel value={true} control={<Radio color="primary" />} label="Double Dipping" />
                    <FormControlLabel value={false} control={<Radio color="primary" />} label="Priority Based" />
                  </RadioGroup>
                </FormControl>
              ) : (
                <span className={classes.label}> {categoryType===true?'Double Dipping':'Priority Based'}</span>
              )}
            </Grid>
          </Grid>
        </Grid> */}

        {/* {
          categoryType===false?
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={2}>
                <strong className={classes.label}>{t('Priority')} : </strong>
              </Grid>
              <Grid item xs={10}>                
                <div className={classes.tableDiv}>
                  <Table
                    headings={
                      [
                        "",
                        "Promotion",
                        "Status"
                      ]
                    }
                    data={(allPromo).map((p, k) => [
                      [
                        isEdit? (
                          <GreenRadio
                            checked={selectedPromo===p?.promotion_id}
                            onChange={() => {
                              handleSelectPromo(p?.promotion_id);
                              setStates({
                                edittedData: {
                                  ...edittedData,
                                  priority:p?.promotion_id
                                }
                              });
                            }}
                            name='radio-button-demo'
                            inputProps={{ 'aria-label': 'C' }}
                          />
                        )
                        :
                        (p?.priority===true) ? (
                          <span style={{ color: "green" }} key={k}>
                            <CheckIcon/>
                          </span>
                        ) : (
                          <span style={{ color: "red" }} key={k}>
                            <CloseIcon/>
                          </span>
                        )
                      ],
                      p?.promotion_id,
                      [
                        p?.["is_active"] ? (
                          <span style={{ color: "green" }} key={k}>
                            {t('Active')}
                          </span>
                        ) : p?.["is_active"] != null ? (
                          <span style={{ color: "red" }} key={k}>
                            {t('InActive')}
                          </span>
                        ) : null,
                      ]
                    ])}
                    disablePagination={true}
                  />
                </div>                
              </Grid>
            </Grid>
          </Grid>          
          :
          ''
        } */}

        {
          !selectedCriteria?
          <Grid container style={{ marginTop: 22 }}>
            <Grid item xs={12} sm={12} lg={12}>
              <div className={classes.tableDiv}>
                <Table
                  headings={
                    [
                      "",
                      "category",
                      "category_value",
                      "promotion_id",
                      "start_date",
                      "end_date",
                      "extended_days",
                      "expire_date",
                      "ranking",
                      "type",
                      "frequency",
                      "Status"
                    ]
                  }
                  data={(allPromo||[]).map((p, k) => [
                    [
                      <GreenRadio
                        checked={selectedPromo?.promotion_id===p?.promotion_id}
                        onChange={() => {
                          handleSelectPromo(p);
                        }}
                        name='radio-button-demo'
                        inputProps={{ 'aria-label': 'C' }}
                      />
                    ],
                    p?.category,
                    p?.category_value,
                    p?.promotion_id,
                    p?.start_date,
                    p?.end_date,
                    p?.extended_days,
                    p?.expire_date,
                    p?.ranking,
                    p?.type,
                    p?.frequency,
                    [
                      p?.["is_active"] ? (
                        <span style={{ color: "green" }} key={k}>
                          {t('Active')}
                        </span>
                      ) : p?.["is_active"] != null ? (
                        <span style={{ color: "red" }} key={k}>
                          {t('InActive')}
                        </span>
                      ) : null,
                    ]
                  ])}
                  disablePagination={true}
                />
              </div>
            </Grid>
          </Grid>
          :
          <Loader Loading={state.loading} top={"15%"}></Loader>
        }

      </Grid>        

      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {isEdit && (
            <Fragment>
              <Button
                className={classes.cancelBtn}
                onClick={() => {
                  setDataObj(data);
                  setStates({ isEdit: false, edittedData: {} });
                }}
              >
                {t('Cancel')}
              </Button>
              &nbsp; &nbsp; &nbsp;
              <Button
                className={classes.submitBtn}
                onClick={() => {
                  handleUpdate();
                }}
              >
               {t('Update')}
              </Button>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
